import React from 'react';
import { FaCommentDots } from 'react-icons/fa';
import styles from '../FeedbackPage.module.css'; // Adjust path if needed

const QuestionSection6 = ({
  activeSection,
  generalFeedback,
  handleGeneralFeedbackChange,
  moveToPreviousSection,
  isLoading,
  isError,
  message,
  q1Rating,
  q2Rating,
  q3Rating,
  q5Referral
}) => {
  return (
    <div 
    id="section-6" 
    className={`${styles.questionSection} ${activeSection === 6 ? styles.active : ''}`}
>
    <div className={styles.questionIcon}>
        <FaCommentDots />
    </div>
    <label htmlFor="generalFeedback" className={styles.questionLabel}>
        6. Additional Comments (Optional)
    </label>
    <textarea
        id="generalFeedback"
        className={styles.textarea}
        rows="5"
        placeholder="Any other thoughts, suggestions, or issues?"
        value={generalFeedback}
        onChange={handleGeneralFeedbackChange}
        disabled={isLoading}
    />

    {/* Submission Message */}
    {message && (
        <p className={`${styles.message} ${isError ? styles.errorText : styles.successText}`}>
            {message}
        </p>
    )}

    <div className={styles.navigationButtons}>
        <button 
            type="button" 
            className={`${styles.btn} ${styles.btnSecondary}`} 
            onClick={moveToPreviousSection}
        >
            Previous
        </button>
        <button
            type="submit"
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={isLoading || q1Rating === 0 || q2Rating === 0 || q3Rating === 0 || !q5Referral}
        >
            
            {isLoading ? 'Submitting...' : 'Submit Feedback'}
        </button>
    </div>
</div>
  );
};

export default QuestionSection6;
